import React, { useEffect, useState } from 'react';
import AffiliatesAPI from 'api/AffiliatesAPI';
import { CircularProgress } from '@mui/material';
import { useSnackbar } from 'notistack';

interface IBrowseAffiliates {
  setBrowseMode: any;
  affiliate: any;
  cur_user: any;
}

const BrowseAffiliates: React.FC<IBrowseAffiliates> = ({ setBrowseMode, affiliate, cur_user }) => {
  const [ available, setAvailable ] = useState({ isLoading: true, data: [] });
  const { enqueueSnackbar } = useSnackbar();

  const getAllAffiliates = async() => {
    let results = [];
    const res = await AffiliatesAPI.getAllAffiliates();
    if (res?.success) {
      results = res?.result;
      // filter out current user's affiliation from list
      results = results.filter((aff: any) => aff.name !== cur_user.selected_team.name);
      setAvailable({ isLoading: false, data: results });
    }
  };

  useEffect(() => {
    getAllAffiliates();
  }, []);

  const requestJoin = async(affiliateId: string) => {
    const updates = {
      _id: affiliateId,
      pending: {
        aff_id: affiliate.data._id,
        name: affiliate.data.name,
        admin: affiliate.data.admin,
        type: 'incoming'
      }
    };
    const res = await AffiliatesAPI.updateAffiliate(updates);
    if (res?.success) {
      setAvailable({ isLoading: true, data: [] });
      getAllAffiliates();
    } else {
      enqueueSnackbar('Failed to send follow request', { variant: 'error' });
    }
  };

  return (
    <div className='browse-affiliates-container'>
      <div className='browse-affiliates-header'>
        <div className='browse-affiliates-header-content'>
          <div className='browse-affiliates-icon'>
            <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
              <path d='M12 5V19M5 12H19' stroke='#4895EF' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
            </svg>
          </div>
          <div className='browse-affiliates-header-group'>
            <div className='browse-affiliates-header-primary'>
              Browse Affiliates
            </div>
            <div className='browse-affiliates-header-secondary'>
              Browse available organizations. Requesting to be an affiliate
              will give you access to unique documents and templates.
            </div>
          </div>
        </div>
        <div className='browse-affiliates-header-close' onClick={() => setBrowseMode(false)}>
          <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
            <path d='M18 6L6 18M6 6L18 18' stroke='#BDBEC1' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
          </svg>
        </div>
      </div>
      <div className='browse-affiliates-body'>
        {available.isLoading ? (
          <div>
            <CircularProgress style={{ color: '#0E8BFF' }} />
          </div>
        ) : (
          <div className='browse-affiliates-body-content'>
            <div className='browse-affiliates-options'>
              {available.data.map((group: any, index: number) => (
                <div key={index} className='browse-affiliates-option-row'>
                  <div className='browse-affiliates-option-group'>
                    {/* add later */}
                    {group?.logo?.base64 ? (
                      <img className='browse-affiliates-option-icon' src={group?.logo?.base64} />
                    ) : (
                      <div className='browse-affiliates-option-icon'></div>
                    )}
                    <div className='browse-affiliates-option-text'>
                      <div className='browse-affiliates-option-primary'>
                        {group?.name}
                      </div>
                    </div>
                  </div>
                  {group.members.length === 0 && group.pending.length === 0 ? (
                    <div className='browse-affiliates-request-btn' onClick={() => requestJoin(group._id)}>
                      <div className='browse-affiliates-request-btn-text'>
                        + Request access
                      </div>
                    </div>
                  ) : (
                    <>
                      {group.members.map((member: any) => (
                        <>
                          {member.name === cur_user.selected_team.name && (
                            <div style={{ cursor: 'none' }} className='browse-affiliates-request-btn' onClick={() => requestJoin(group._id)}>
                              <div style={{ color: '#BDBEC1' }} className='browse-affiliates-request-btn-text'>
                                Following
                              </div>
                            </div>
                          )}
                        </>
                      ))}
                      {group.pending.map((pend: any) => (
                        <>
                          {pend.name === cur_user.selected_team.name && (
                            <div style={{ cursor: 'none' }} className='browse-affiliates-request-btn' onClick={() => requestJoin(group._id)}>
                              <div style={{ color: '#BDBEC1' }} className='browse-affiliates-request-btn-text'>
                                Requested
                              </div>
                            </div>
                          )}
                        </>
                      ))}
                    </>
                  )}
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
      <div className='browse-affiliates-footer'>
        <div className='browse-affiliates-footer-wrap'></div>
      </div>
    </div>
  );
};

export default BrowseAffiliates;
